import { StoreDetailsState } from "@core/models/store.interface";
import { createSelector } from "@ngrx/store";

export const selectStoreFeature = (state: {
  storeDetails: StoreDetailsState;
}) => state.storeDetails;

export const selectStoreDetails = createSelector(
  selectStoreFeature,
  (state) => state.storeDetails
);
export const selectStoreLoading = createSelector(
  selectStoreFeature,
  (state) => state.isLoading
);
